/**
 * Umami 埋点工具
 */

declare global {
    interface Window {
        umami?: {
            track: (key: string, data?: Record<string, any>) => void;
        };
    }
}

/** 埋点事件枚举 */
export enum TrackEvent {
    /** 点击悬浮球（打开对话） */
    FloatBoxOpen = 'float_box_open_click',
    /** 点击预制问题 */
    FloatBoxPreset1 = 'float_box_preset_1_click',
    FloatBoxPreset2 = 'float_box_preset_2_click',
    FloatBoxPreset3 = 'float_box_preset_3_click',
    FloatBoxPreset4 = 'float_box_preset_4_click',
    FloatBoxPreset5 = 'float_box_preset_5_click',
    FloatBoxPreset6 = 'float_box_preset_6_click',
    FloatBoxPreset7 = 'float_box_preset_7_click',
    FloatBoxPreset8 = 'float_box_preset_8_click',
    /** 复制悬浮球问题答案 */
    FloatBoxCopyAnswer = 'float_box_copy_answer',
    /** 发送问题（非预制，通过 socket 提交） */
    FloatBoxSendQuestion = 'float_box_send_question',
    /** 登录成功 */
    LoginSuccess = 'login_success',
}

/** 登录来源标记（sessionStorage key），登录前写入、登录成功后读取并清除 */
export const LOGIN_SOURCE_KEY = 'floatBox_login_source';

/** 预制问题点击埋点 key 列表（与预制问题顺序一一对应） */
export const FLOAT_BOX_PRESET_KEYS: TrackEvent[] = [
    TrackEvent.FloatBoxPreset1,
    TrackEvent.FloatBoxPreset2,
    TrackEvent.FloatBoxPreset3,
    TrackEvent.FloatBoxPreset4,
    TrackEvent.FloatBoxPreset5,
    TrackEvent.FloatBoxPreset6,
    TrackEvent.FloatBoxPreset7,
    TrackEvent.FloatBoxPreset8,
];

/** 获取 Umami 实例（脚本未加载时为 undefined） */
const getUmami = () => (window as any).umami;

/**
 * 上报自定义事件（可附带用户信息）
 * @param key 事件名
 * @param data 额外数据
 */
export function pushTrack(key: string, data?: Record<string, any>) {
    const umami = getUmami();
    if (!umami) return;
    const payload: Record<string, any> = { ...data };
    try {
        const { userState } = useStore('user');
        payload.userId = userState.value?.userId;
        payload.nickname = userState.value?.nickname;
    } catch (e) {
        // 用户信息不可用时仅上报事件本身
    }
    umami.track(key, payload);
}

/**
 * 上报路由变化（页面浏览）
 * @param url 当前页面路径
 * @param referrer 来源页面路径
 */
export function trackRouteChange(url: string, referrer: string) {
    const umami = getUmami();
    if (!umami) return;
    umami.track((props: any) => ({ ...props, url, referrer }));
}
